/**
 * 통합관리 라우트용 지연 로딩 래퍼 — 화면별 청크. router/routes.tsx 가 element 로만 쓴다.
 * (lazy 선언을 routes.tsx 에 두면 그 파일의 Fast Refresh 경고가 늘어나서 컴포넌트만 내보내는 이 파일에 모았다)
 */
import { lazy, Suspense, type ComponentType } from "react";

const Shell = lazy(() => import("./GroupShell").then((m) => ({ default: m.GroupShell })));
const Users = lazy(() => import("./UsersList").then((m) => ({ default: m.UsersList })));
const Log = lazy(() => import("./AccessLog").then((m) => ({ default: m.AccessLog })));
const Admins = lazy(() => import("./AdminsPage").then((m) => ({ default: m.AdminsPage })));
const Workday = lazy(() => import("./WorkdayPage").then((m) => ({ default: m.WorkdayPage })));
const Notify = lazy(() => import("./NotifyPage").then((m) => ({ default: m.NotifyPage })));
const Brand = lazy(() => import("./BrandPage").then((m) => ({ default: m.BrandPage })));
const Ranks = lazy(() => import("./RanksPage").then((m) => ({ default: m.RanksPage })));
const Company = lazy(() => import("./CompanyPage").then((m) => ({ default: m.CompanyPage })));

function Fallback() {
  // group.css 는 껍데기와 함께 늦게 로드되므로 인라인 토큰으로
  return (
    <div role="status" style={{ padding: "var(--sp-10)", textAlign: "center", color: "var(--c-text-muted)", fontSize: "var(--fs-base)" }}>
      불러오는 중…
    </div>
  );
}
function wrap(El: ComponentType) {
  return (
    <Suspense fallback={<Fallback />}>
      <El />
    </Suspense>
  );
}

export function GroupShellRoute() { return wrap(Shell); }
export function GroupUsersRoute() { return wrap(Users); }
export function GroupAccessLogRoute() { return wrap(Log); }
export function GroupAdminsRoute() { return wrap(Admins); }
export function GroupWorkdayRoute() { return wrap(Workday); }
export function GroupNotifyRoute() { return wrap(Notify); }
export function GroupBrandRoute() { return wrap(Brand); }
export function GroupRanksRoute() { return wrap(Ranks); }
export function GroupCompanyRoute() { return wrap(Company); }
